{
  "PAGINATION_FOOTER": {
    "SHOWING": "{totalItems}개 항목 중 {startItem} - {endItem} 표시 | {totalItems}개 항목 중 {startItem} - {endItem} 표시",
    "CURRENT_PAGE_INFO": "{totalPages} 페이지 중 {currentPage} | {totalPages} 페이지 중 {currentPage}"
  },
  "COMBOBOX": {
    "PLACEHOLDER": "옵션을 선택하십시오...",
    "EMPTY_SEARCH_RESULTS": "검색어 `{searchTerm}`에 대한 항목을 찾을 수 없습니다",
    "EMPTY_STATE": "검색 결과가 없습니다.",
    "SEARCH_PLACEHOLDER": "검색...",
    "MORE": "+{count}개 더"
  },
  "DROPDOWN_MENU": {
    "SEARCH_PLACEHOLDER": "검색...",
    "EMPTY_STATE": "검색 결과가 없습니다.",
    "SEARCHING": "검색중..."
  },
  "DIALOG": {
    "BUTTONS": {
      "CANCEL": "취소",
      "CONFIRM": "확인"
    }
  },
  "PHONE_INPUT": {
    "SEARCH_PLACEHOLDER": "국가 검색",
    "ERROR": "전화번호는 비어 있거나 E.164 형식이어야 합니다",
    "DIAL_CODE_ERROR": "목록에서 국가 번호를 선택하십시오"
  },
  "THUMBNAIL": {
    "AUTHOR": {
      "NOT_AVAILABLE": "작성자를 사용할 수 없습니다"
    }
  },
  "BREADCRUMB": {
    "ARIA_LABEL": "브레드크럼"
  },
  "SWITCH": {
    "TOGGLE": "스위치 전환"
  },
  "LABEL": {
    "TAG_BUTTON": "태그"
  },
  "FEATURE_SPOTLIGHT": {
    "LEARN_MORE": "더 알아보기",
    "WATCH_VIDEO": "동영상 보기"
  },
  "DURATION_INPUT": {
    "MINUTES": "분",
    "HOURS": "시간",
    "DAYS": "일",
    "PLACEHOLDER": "기간을 입력하십시오"
  },
  "CHANNEL_SELECTOR": {
    "COMING_SOON": "곧 출시 예정!"
  },
  "SLASH_COMMANDS": {
    "HEADING_1": "Heading 1",
    "HEADING_2": "Heading 2",
    "HEADING_3": "Heading 3",
    "BOLD": "Bold",
    "ITALIC": "Italic",
    "STRIKETHROUGH": "Strikethrough",
    "CODE": "Code",
    "BULLET_LIST": "Bullet List",
    "ORDERED_LIST": "Ordered List",
    "TABLE": "Table",
    "IMAGE": "Image"
  }
}
